export const Logo = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lg-mark" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E9CF7E" />
        <stop offset="1" stopColor="#C89B2C" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" stroke="url(#lg-mark)" strokeWidth="2" />
    <path
      d="M32 51C21 45.5 14.5 36 16.5 25.5 17.8 18.6 24 13.5 31.5 13.6c.2-2 .9-4 2.9-4.6 2.1-.6 3.6 1.3 3.1 3.4 6.9 1.3 11.6 7.4 10.9 14.6C47.6 37.6 40.8 46.4 32 51Z"
      fill="url(#lg-mark)"
      opacity="0.94"
    />
    <path d="M33.5 17c-3.2 6.5-3.6 15-1.6 28" stroke="#0B192C" strokeWidth="2.2" strokeLinecap="round" />
    <path
      d="M24 27c3.5 1.6 6.3 3.8 8.3 6.6M42 25.5c-3.8 2-6.7 4.6-8.7 7.8"
      stroke="#0B192C"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);
